import { render, staticRenderFns } from "./viewRocords.vue?vue&type=template&id=7a0a9da5&scoped=true&"
import script from "./viewRocords.vue?vue&type=script&lang=js&"
export * from "./viewRocords.vue?vue&type=script&lang=js&"
import style0 from "./viewRocords.vue?vue&type=style&index=0&id=7a0a9da5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a9da5",
  null
  
)

export default component.exports